export default __webpack_public_path__ + "static/media/table.37e18153.png";